import debounce from '@ts/utils/debounce';

class BackToTopButtonInitService {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('alpine:init', () => {
            Alpine.data('backToTopButton', () => ({
                open: false,

                backToTopButtonAttributes: {
                    ['x-show']() {
                        return this.open;
                    },
                    ['x-transition:enter']: 'fade-in',
                    ['x-transition:leave']: 'fade-out',
                    ['@click']() {
                        this.handleClick();
                    },
                },

                handleClick() {
                    (document.querySelector('#target-top') as HTMLElement).focus({
                        preventScroll: true,
                    });
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                },

                init() {
                    if (window.scrollY > 300) {
                        this.open = true;
                    }
                    window.onscroll = debounce(() => {
                        if (window.scrollY > 300) {
                            this.open = true;
                        } else {
                            this.open = false;
                        }
                    }, 150);
                },
            }));
        });
    }
}

export default new BackToTopButtonInitService();
